import { render, staticRenderFns } from "./MinePost.vue?vue&type=template&id=c35a09cc&"
import script from "./MinePost.vue?vue&type=script&lang=ts&"
export * from "./MinePost.vue?vue&type=script&lang=ts&"
import style0 from "./MinePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports